import React from 'react'

import ContractDocumentTable from './ContractTable/ContractDocumentTable'

import Section from '../../../../../../components/Section'
import { Contract } from '../../../types'

import { ContractDocumentsError } from '../types'

type Props = {
    theme: string
    contractAction: boolean
    contractGuid: string | undefined
    contract: Contract
    role: string
    onContractDocuments: (have_contract_documents: boolean) => void
    errors?: ContractDocumentsError
    // onAnyEdit: () => void
}

const ContractDocuments: React.FC<Props> = (props) => {
    return (
        <Section title="Документы">
            <div className="flex flex-col w-full gap-x-5 space-y-3">
                <div className="flex flex-col w-full gap-x-5 ">
                    <div className={`flex flex-col min-w-[200px]`}>
                        <ContractDocumentTable
                            theme={props.theme}
                            contractAction={props.contractAction}
                            contractGuid={props.contractGuid}
                            role={props.role}
                            onContractDocuments={props.onContractDocuments}
                            errors={props.errors}
                            // onAnyEdit={props.onAnyEdit}
                        />
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default ContractDocuments
